import React, { Component } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import companyService from '../../api/companiesService';

export default class ConfirmDeleteCompany extends Component {
    constructor(props) {
        super(props);

        this.deleteCompany = this.deleteCompany.bind(this);
    }

    deleteCompany() {
        const { id } = this.props.company;
        companyService.deleteCompany(id)
            .then(() => {
                this.props.onClose();
            });
    }

    render() {
        const { showConfirm, onClose, company } = this.props;
        if (company) {
            return (
                <Dialog
                    open={showConfirm}
                    onClose={onClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Delete this Company?</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            You are deleting {company.name}'. That will deactivate <b>all</b> {company.name}'s accounts. This can't be undone. Do you want to proceed?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClose} color="primary">No, go back</Button>
                        <Button onClick={this.deleteCompany} color="primary" autoFocus>Yes, delete all</Button>
                    </DialogActions>
                </Dialog>
            );
        } else {
            return null;
        }
    }
}